import { put, call, take, fork } from 'redux-saga/effects'
import { excelExportAutoSenderReportService } from '../../api/excel-report'
import FileDownload from 'js-file-download'
import { COURSE_REPORT } from '../../reducers/course/type'
import { courseReportSuccess } from '../../reducers/course/action'

import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* courseReportFlow(payload) {
  try {
    const { id } = payload

    const response = yield call(excelExportAutoSenderReportService, id)

    yield put(courseReportSuccess())

    FileDownload(response, 'report.xlsx')

    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* courseListWatcher() {
  while (true) {
    const action = yield take(COURSE_REPORT)
    const { payload } = action

    yield fork(generalSaga, courseReportFlow, payload)
  }
}
